import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpiresFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 122,
	height: 32,
	viewBox: "0 0 122 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	preserveAspectRatio: "none",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M122 0c-3.671 6.044-8.602 11.36-14.65 15.468-10.389 7.059-22.224 9.639-33.519 8.343-1.351-.154-2.59-.314-3.749-.463-7.064-.912-11.073-1.43-18.62 2.063-.106.048-8.993 4.346-9.001 4.351C30.295 35.89 15.499 28.65 6.774 17.568 2.978 12.053.497 6.015 0 0h122z",
		fill: "currentColor"
	})
});
export default SvgExpiresFlag;
